import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconLive360 } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { toggleLocal360 } from '../../../local-360/actions';
// Ensure the local-360 reducer is registered when this button is loaded
import '../../../local-360/reducer';
//const YOUTUBE_360_ID = 'msyeWjb-eTQ';
class Play360Button extends AbstractButton {
    accessibilityLabel = 'Live 360 View';
    toggledAccessibilityLabel = 'Stop Live 360 View';
    icon = IconLive360;
    label = 'Live 360 View';
    toggledLabel = 'Stop Live 360 View';
    tooltip = 'Live 360 View';
    toggledTooltip = 'Stop Live 360 View';
    _handleClick() {
        this.props.dispatch(toggleLocal360(this.props._local360Id));
    }
    _isToggled() {
        return this.props._isSharingThis360;
    }
    _isDisabled() {
        return this.props._isDisabled;
    }
}
function _mapStateToProps(state) {
    // Read from runtime config; fallback to your current default ID
    const { local360VideoId } = state['features/base/config'] || {};
    const fallbackId = 'msyeWjb-eTQ';
    const _local360Id = local360VideoId || fallbackId;
    const { isOpen, videoId } = state['features/local-360'] || {};
    const _isSharingThis360 = Boolean(isOpen && videoId === _local360Id);
    const _isDisabled = false;
    return { _isDisabled, _isSharingThis360, _local360Id };
}
export default translate(connect(_mapStateToProps)(Play360Button));
